import { isAppointmentService, isClassService, isCourseService } from '../service/service';
const isDateInCurrentYear = date => {
  const now = new Date();
  return now.getFullYear() === date.getFullYear();
};
const isDateInThePast = date => {
  const now = new Date();
  return date.getTime() < now.getTime();
};
const getCourseDuration = _ref => {
  var _service$schedule, _service$schedule2, _service$schedule3;
  let {
    durationFormatter,
    durationsMapperKeys,
    service,
    viewTimezone,
    dateRegionalSettingsLocale
  } = _ref;
  const isPassedEndDate = !(service != null && (_service$schedule = service.schedule) != null && _service$schedule.lastSessionEnd) || (service == null || (_service$schedule2 = service.schedule) == null ? void 0 : _service$schedule2.lastSessionEnd) < new Date();
  if (isPassedEndDate) {
    return durationFormatter(durationsMapperKeys.courseEndedText);
  }
  const startDateAsUTC = service == null || (_service$schedule3 = service.schedule) == null || (_service$schedule3 = _service$schedule3.firstSessionStart) == null ? void 0 : _service$schedule3.toUTCString();
  if (startDateAsUTC) {
    const startDate = new Date(startDateAsUTC);
    const dateFormat = isDateInCurrentYear(startDate) ? {
      month: 'short',
      day: 'numeric',
      timeZone: viewTimezone
    } : {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: viewTimezone
    };
    const formattedDate = new Intl.DateTimeFormat(dateRegionalSettingsLocale, dateFormat).format(startDate);
    return isDateInThePast(startDate) ? durationFormatter(durationsMapperKeys.coursePassedText, {
      date: formattedDate,
      interpolation: {
        escapeValue: false
      }
    }) : durationFormatter(durationsMapperKeys.courseInFutureText, {
      date: formattedDate,
      interpolation: {
        escapeValue: false
      }
    });
  }
  return '';
};
export const getDurationText = _ref2 => {
  var _selectedVariant$choi, _service$schedule4, _service$schedule5, _service$schedule6;
  let {
    dateRegionalSettingsLocale,
    service,
    durationsMapperKeys,
    durationFormatter,
    viewTimezone,
    durationAria = false,
    isDynamicDurationUOUEnable = false,
    selectedVariant
  } = _ref2;
  const commonDurationFormatterArgs = {
    hourUnit: durationsMapperKeys.hourUnit,
    minuteUnit: durationsMapperKeys.minuteUnit,
    durationFormatter,
    durationAria
  };
  const variantDuration = selectedVariant == null || (_selectedVariant$choi = selectedVariant.choices) == null || (_selectedVariant$choi = _selectedVariant$choi[0]) == null || (_selectedVariant$choi = _selectedVariant$choi.duration) == null ? void 0 : _selectedVariant$choi.minutes;
  if (variantDuration) {
    return formatDurationFromMinutes({
      ...commonDurationFormatterArgs,
      durationInMinutes: variantDuration
    });
  }
  const sessionsDuration = isDynamicDurationUOUEnable && service != null && (_service$schedule4 = service.schedule) != null && (_service$schedule4 = _service$schedule4.availabilityConstraints) != null && (_service$schedule4 = _service$schedule4.durations) != null && _service$schedule4.length ? [...new Set(service == null || (_service$schedule5 = service.schedule) == null || (_service$schedule5 = _service$schedule5.availabilityConstraints) == null || (_service$schedule5 = _service$schedule5.durations) == null ? void 0 : _service$schedule5.map(duration => duration == null ? void 0 : duration.minutes).sort((a, b) => a - b))] : service == null || (_service$schedule6 = service.schedule) == null || (_service$schedule6 = _service$schedule6.availabilityConstraints) == null ? void 0 : _service$schedule6.sessionDurations;
  const firstSessionDuration = sessionsDuration == null ? void 0 : sessionsDuration[0];
  const isDurationVaries = (sessionsDuration == null ? void 0 : sessionsDuration.some(duration => duration !== firstSessionDuration)) || false;
  if (isCourseService(service)) {
    return getCourseDuration({
      dateRegionalSettingsLocale,
      service,
      viewTimezone,
      durationsMapperKeys,
      durationFormatter
    });
  }
  if (isDynamicDurationUOUEnable && isAppointmentService(service)) {
    if (!sessionsDuration || sessionsDuration.length < 1) {
      return '';
    }
    if (sessionsDuration.length > 1) {
      const min = formatDurationFromMinutes({
        ...commonDurationFormatterArgs,
        durationInMinutes: sessionsDuration[0]
      });
      const max = formatDurationFromMinutes({
        ...commonDurationFormatterArgs,
        durationInMinutes: sessionsDuration[sessionsDuration.length - 1]
      });
      return durationFormatter(durationsMapperKeys.durationRange, {
        min,
        max
      });
    } else {
      return formatDurationFromMinutes({
        ...commonDurationFormatterArgs,
        durationInMinutes: (sessionsDuration == null ? void 0 : sessionsDuration[0]) || 0
      });
    }
  }
  if (isDurationVaries && isClassService(service)) {
    return durationFormatter(durationsMapperKeys.durationVaries);
  }
  if (firstSessionDuration) {
    return formatDurationFromMinutes({
      ...commonDurationFormatterArgs,
      durationInMinutes: firstSessionDuration || 0
    });
  }
  return '';
};
const formatDurationFromMinutes = _ref3 => {
  let {
    durationInMinutes,
    hourUnit,
    minuteUnit,
    durationFormatter,
    durationAria = false
  } = _ref3;
  const hours = Math.floor(durationInMinutes / 60);
  const minutes = durationInMinutes % 60;
  let hourText = durationFormatter(hourUnit, {
    hours
  });
  if (durationAria) {
    hourText = hours === 1 ? hourText.slice(0, -1) : hourText;
  }
  const minuteText = durationFormatter(minuteUnit, {
    minutes
  });
  return hours ? hourText + (minutes ? ` ${minuteText}` : '') : minuteText;
};
//# sourceMappingURL=duration.js.map